import axios from 'axios';

/**
 * @deprecated use findPortAdmin for admin panel
 */
export function findPort({ 
    name, 
    withAreas = false, 
    onlyAreas = false, 
    country = '', 
    onlyAreasWithChild = false, 
    withAreasWithChild = false, 
    mainRegions = false,
    isInBalticIndex = false,
}) {
    return axios({
        method: 'POST',
        url: '/api/v1/ports/find',
        data: {
            name,
            withAreas,
            onlyAreas,
            country,
            onlyAreasWithChild,
            withAreasWithChild,
            mainRegions,
            isInBalticIndex,
        },
        withCredentials: true,
    });
}

export function findPortAdmin({ 
    name, 
    withAreas = false, 
    onlyAreas = false, 
    country = '', 
    onlyAreasWithChild = false, 
    withAreasWithChild = false, 
    mainRegions = false,
    isInBalticIndex = false,
}) {
    return axios({
        method: 'POST',
        url: '/api/v2/adminPanel/ports/find',
        data: {
            name,
            withAreas,
            onlyAreas,
            country,
            onlyAreasWithChild,
            withAreasWithChild,
            mainRegions,
            isInBalticIndex,
        },
        withCredentials: true,
    });
}

export function getAllPorts() {
    return axios({
        method: 'GET',
        url: '/api/v1/ports/allPorts',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getPorts({
    page = 1, limit = 25, sort = 'name', onlyChanged = false, query = '', 
}) {
    return axios({
        method: 'GET',
        url: `/api/v1/ports?page=${page}&limit=${limit}&sort=${sort}&onlyChanged=${onlyChanged}&query=${query}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getAllPortsWithAltNames() {
    return axios({
        method: 'GET',
        url: '/api/v1/ports/all',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function getAllPortsWithCountryNames() {
    return axios({
        method: 'GET',
        url: '/api/v1/ports/names',
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function updatePort(data) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/${data._id}`,
        data,
        withCredentials: true,
    })
        .then(response => 
        //  console.log('then response ---> ', response);
            response.data)
        .catch(response => 
        //  console.log('catch response ---> ', response.response);
            response.response.data);
}

export function updatePortAlt(item) {
    return axios({
        method: 'PUT',
        url: `/api/v1/ports/${item._id}/alt`,
        data: {
            alt: item.alt,
        },
        withCredentials: true,
    })
        .then(response => ({
            ...response.data,
            item,
        }))// todo sending response.response
        .catch(response => ({
            ...response.response.data,
            item,
        }));
}

export function addNewPort(data) {
    return axios({
        method: 'post',
        url: '/api/v1/ports/',
        data,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getPort(data) {
    const all = data.all ? data.all : false;
    const url = data.history ? `/api/v1/ports/${data.id}/history?all=${all}` : `/api/v1/ports/${data.id}`;

    return axios({
        method: 'get',
        url,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response);
}

export function checkAndCreateRegion(name) {
    return axios({
        method: 'post',
        url: '/api/v1/ports/areas/check',
        withCredentials: true,
        data: {
            name,
        },
    });
}

export function mergeAreaOrPortToPort(portId, mergePortId) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${portId}/merge`,
        withCredentials: true,
        data: {
            mergeId: mergePortId,
        },
    });
}

export function rejectPortModifications(data) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${data._id}/reject`,
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
        },
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function approvePortModifications(data) {
    return axios({
        method: 'put',
        url: `/api/v1/ports/${data._id}/approve`,
        withCredentials: true,
        data: {
            _id: data.historyId,
            lastUpdate: data.updateAt,
        },
    })
        .then(response => response.data)
        .catch(response => response.data);
}




// WEBPACK FOOTER //
// ./app/services/regions/ports.js